function initSlick() {
  $('.slick-section').each(function() {
    const $slider = $(this);
    
    // Get the slidesToShow and arrow settings
    const slidesToShowSetting = parseInt($slider.attr('data-slides-to-show'), 10);
    const slidesToShow = slidesToShowSetting / 10;
    const showArrows = $slider.data('show-arrows');
    const showDots = $slider.data('show-dots');
    
    // Log for debugging
    // console.log('Slides to Show:', slidesToShow, 'Show Arrows:', showArrows);
    
    // Initialize or reinitialize Slick slider
    if ($(window).width() <= 768) {
      if (!$slider.hasClass('slick-initialized')) {
        // console.log('Initializing Slick Slider');
        $slider.slick({
          infinite: false,
          speed: 300,
          dots: showDots,
          arrows: showArrows, 
          prevArrow: showArrows ? '<button type="button" class="slick-prev"><svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 1L2 8L9 15" stroke="black" stroke-width="1.5"/></svg></button>' : null,
          nextArrow: showArrows ? '<button type="button" class="slick-next"><svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L8 8L1 15" stroke="black" stroke-width="1.5"/></svg></button>' : null,
          slidesToShow: slidesToShow,
          slidesToScroll: 1,
          responsive: [
            {
              breakpoint: 480,
              settings: {
                slidesToShow: slidesToShow,
                slidesToScroll: 1,
              },
            },
          ],
        });
      } else {
        // console.log('Refreshing Slick Slider');
        $slider.slick('refresh');
      }
    } else {
      if ($slider.hasClass('slick-initialized')) {
        // console.log('Destroying Slick Slider');
        $slider.slick('unslick');
      }
    }
  });
}

$(document).ready(function () {
  initSlick();
  $(window).on('resize', function () {
    initSlick();
  });
});
